import * as React from "react";
const SvgAddComment = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2v16h16l4 4V2Zm-5 9h-4v4h-2v-4H7V9h4V5h2v4h4v2Z",
  fill: "currentColor"
}));
export default SvgAddComment;